import axios from 'axios'
let route = process.env.VUE_APP_API_ROUTE + '/acc_cost_center'

const findByName = async function(name) {
    try {
        let response = await axios.get(route + '?filter[name_exact]=' + name)
        return response.data
    } catch (error) {
        return error.response.data
    }
}

export { findByName }
